import { combineReducers } from '@reduxjs/toolkit'
import gameSetting from './slices/gameSettings.slice'
import authSlice from './slices/auth.slice'
import kenoGame from 'games/Keno/slice-thunk/kenoGame.slice'
import crashGame from 'games/CrashGames/slice-thunk/crashGame.slice'
import newCrashGame from './slices/newCrashGame.slice'
import plinkoGame from 'games/Plinko/slices-thunks/plinkoGame.slice'
import pyramidPlinkoGame from 'games/Plinko/slices-thunks/pyramidPlinkoGame.slice'
import mineGame from 'games/Mines/slices-thunks/mineGame.slice'
import blackjackGame from 'games/BlackJack/slice-thunk/blackjack.slice'
import diceGame from 'games/Dice/slices-thunks/diceGame.slice'
import diceStrategy from 'games/Dice/slices-thunks/diceStrategy.slice'
import videoPokerGame from 'games/VidePoker/slice-thunk/videoPoker.slice'
import hiLoGame from 'games/HiLo/slice-thunk/hiLoGame.slice'
import limboGame from 'games/Limbo/slice-thunk/limboGame.slice'
import spaceDiceGame from 'games/Dice/slices-thunks/spaceDiceGame.slice'
import rouletteGame from 'games/Roulette/slice-thunk/rouletteGame.slice'
import flipCoinGame from 'games/FlipCoin/slice-thunk/flipCoinGame.slice'
import tapTapMineGame from 'games/Mines/slices-thunks/gongaMineGame.slice'
import soccerCrashGame from 'games/CrashGames/GameTheme/SoccerCrashGame/slice-thunk/soccerCrashGame.slice'
import bbCrossGame from 'games/BbCrossGame/slice-thunks/bbCrossGame.slice'
import chat from './slices/chat.slice'
import towerGame from 'games/TowerGame/slice-thunk/towerGame.slice'
import magicaSpellGame from 'games/PenaltyShootoutGame/slice-thunk/penaltyShootoutGame.slice'
// import followTheArrowGame from './slices/followTheArrowGame.slice'
import thunderStrikeGame from './slices/thunderStrikeGame.slice'
// import galaxyGrabGame from './slices/galaxyGrabGame.slice'
// import aztecManGame from './slices/aztecManGame.slice'
import balloonPumpGameSlice from 'games/BalloonGame/slice-thunk/balloonPumpGame.slice'
import loader from './slices/loader.slice'
import footballGameSlice from 'games/FootballGame/slice-thunk/footballGame.slice'
import gamificationSlice from './slices/gamification.slice'

const rootReducer = combineReducers({
  gameSetting,
  crashGame,
  newCrashGame,
  soccerCrashGame,
  plinkoGame,
  kenoGame,
  hiLoGame,
  diceGame,
  limboGame,
  mineGame,
  pyramidPlinkoGame,
  tapTapMineGame,
  blackjackGame,
  diceStrategy,
  rouletteGame,
  spaceDiceGame,
  videoPokerGame,
  flipCoinGame,
  auth: authSlice,
  loader,
  chat,
  gamification: gamificationSlice,
  // aztecManGame,
  // followTheArrowGame,
  thunderStrikeGame,
  // galaxyGrabGame
  bbCrossGame,
  towerGame,
  balloonPumpGameSlice,
  magicaSpellGame,
  footballGameSlice
})

export default rootReducer
